


import { createAction, createActionGroup, emptyProps, props } from '@ngrx/store';
import { BlogItemStatusEnum, BlogPostItem, CreateOrUpdateBlogPostDTO } from '../../../../../models/blog.model';
import { SystemProcessLoadingStatus } from 'src/app/models/global-classes';



export const WebsiteBlogListActions = createActionGroup({
  source: ' Load Website Blog Posts',
  events: {
    load:emptyProps(),
    loadSuccess:props<{ posts: BlogPostItem[] }>(),
    loadFailure: props<{ error: any }>(),
  },
});

export const WebsiteBlogCurrentArticleActions = createActionGroup({
  source: ' Load Website Blog Current Article',
  events: {
    load:props<{id: number, errorHandler: any}>(),
    loadSuccess:props<{ post: BlogPostItem }>(),
    loadFailure: props<{ error: any }>(),
  },
});


export const WebsiteBlogCreateActions = createActionGroup({
  source: ' Create Website Blog Post',
  events: {
    create:props<{ payload: CreateOrUpdateBlogPostDTO }>(),
    loadSuccess:props<{ post: BlogPostItem }>(),
    loadFailure: props<{ error: any }>(),
  },
});


export const updateWebsiteBlogPostActions = createActionGroup({
  source: ' Update post',
  events: {
    update:props<{postId: number, changes: Partial<CreateOrUpdateBlogPostDTO>}>(),
    updateSuccess: props<{ post: BlogPostItem }>(),
    updateFailure: props<{ error: any }>(),

  },
});

export const deleteWebsiteBlogPostActions = createActionGroup({
  source: 'Delete post',
  events: {
    delete: props<{ postId: number }>(),
    deleteSuccess: props<{ postId: number }>(),
    deleteFailure: props<{ postId: number, error: any }>(),
  },
});



export const updatePostStatusActions = createActionGroup({
  source: ' Update post Status',
  events: {
    update:props<{postId: number,  status: BlogItemStatusEnum}>(),

  },
});


